export function normalizeWorkTimeMeasure(measure) {
  if (!measure) return null;
  const number = (value) => value == null || String(value).trim() === ""
    ? NaN : Number(String(value).trim().replace(",", "."));
  const percentage = number(measure.percentage);
  // Older documents used the weeklyHours field for the entered hour count.
  // All work-time measures now represent a complete month.
  const hours = number(measure.monthlyHours ?? measure.weeklyHours);
  if (!Number.isFinite(percentage) || percentage < 0 || percentage > 100 ||
      !Number.isFinite(hours) || hours < 0 || hours > 744) return null;
  const { weeklyHours, ...rest } = measure;
  return { ...rest, percentage, monthlyHours: hours };
}

export function employeeWorkTime(employee, measures) {
  return normalizeWorkTimeMeasure(measures?.[employee?.workTimeId]);
}

export function monthlyWorkTimeHours(measure) {
  return normalizeWorkTimeMeasure(measure)?.monthlyHours ?? null;
}

export function workTimeHoursLabel(measure) {
  return `${Number(measure.monthlyHours ?? measure.weeklyHours).toLocaleString("sv-SE")} h/mån`;
}
